import { Actions, createEffect, ofType } from '@ngrx/effects'
import { map } from 'rxjs'

import { Injectable } from '@angular/core'
import { ChangeRequestActions } from '../actions/change-request.actions'
import { ChangeItemType, ChangeType } from '../../model'

@Injectable()
export class ChangeRequestSectionEffects {
  constructor(private actions$: Actions) {}

  addSection$ = createEffect(() =>
    this.actions$.pipe(
      ofType(ChangeRequestActions.addSection),
      map(({ data }) =>
        ChangeRequestActions.applyChanges({
          payload: {
            changeType: ChangeType.ADDED,
            type: ChangeItemType.SCOPE_SECTION,
            identity: data.id,
            data,
          },
        })
      )
    )
  )

  deleteSection$ = createEffect(() =>
    this.actions$.pipe(
      ofType(ChangeRequestActions.deleteSection),
      map(({ sectionId }) =>
        ChangeRequestActions.applyChanges({
          payload: {
            changeType: ChangeType.REMOVED,
            type: ChangeItemType.SCOPE_SECTION,
            identity: sectionId,
          },
        })
      )
    )
  )
}
